import { HttpClient } from "@angular/common/http";
import { Observable, BehaviorSubject, of } from "rxjs";
import { fromPromise } from "rxjs/observable/fromPromise";
import { tap, filter, first, map, flatMap } from "rxjs/operators";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class Cache {
    constructor(storage) {
        this.storage = storage;
        this.cacheableTime = new Map();
        this.cacheMap = new Map();
    }
    get(req) {
        let entry = this.cacheMap.get(req);
        if (!entry) {
            return this.storage.get(req).then(value => {
                if (value !== null) {
                    entry = (value);
                    this.cacheMap.set(req, entry);
                    let max_time;
                    Array.from(this.cacheableTime.keys()).forEach(value => {
                        if (entry.url.includes(value)) {
                            max_time = this.cacheableTime.get(value);
                        }
                    });
                    const isExpired = Date.now() - entry.entryTime < max_time;
                    return Promise.resolve({
                        data: entry.response,
                        isExpired: isExpired
                    });
                }
                else {
                    return Promise.resolve({ data: undefined, isExpired: true });
                }
            });
        }
        else {
            let max_time;
            Array.from(this.cacheableTime.keys()).forEach(value => {
                if (entry.url.includes(value)) {
                    max_time = this.cacheableTime.get(value);
                }
            });
            const isExpired = Date.now() - entry.entryTime < max_time;
            return Promise.resolve({ data: entry.response, isExpired: isExpired });
        }
    }
    put(req, res) {
        const entry = {
            url: req,
            response: res,
            entryTime: Date.now()
        };
        this.cacheMap.set(req, entry);
        this.storage.set(req, JSON.stringify(entry)).then(value => { });
        this.deleteExpiredCache(req);
    }
    deleteExpiredCache(url) {
        let max_time;
        Array.from(this.cacheableTime.keys()).forEach(value => {
            if (url.includes(value)) {
                max_time = this.cacheableTime.get(value);
            }
        });
        this.cacheMap.forEach(entry => {
            if (Date.now() - entry.entryTime > max_time) {
                this.cacheMap.delete(entry.url);
                this.storage.remove(entry.url);
            }
        });
    }
    isRequestCachable(req) {
        const cacheableTime = this.cacheMap.has(req.url) ? req.url : "";
        return req.url.indexOf(cacheableTime) > -1;
    }
}
export function applicationHttpClientCreator(http, cache) {
    return new CachedHttpService(http, cache);
}
/*
  Generated class for the CacheInterceptService provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
export class CachedHttpService {
    constructor(http, cache) {
        this.http = http;
        this.cache = cache;
        this.cachedSubjects = new Map();
        this.cacheableTime = new Map();
    }
    get(url, options, optionsCache) {
        const cacheHandler = new BehaviorSubject(undefined);
        const cacheObResponse$ = cacheHandler
            .asObservable()
            .pipe(filter(a => a !== undefined));
        const cachedResponse = fromPromise(this.cache.get(this.constructUrl(url, options ? options.params : undefined)))
            .pipe(flatMap(a => {
            cacheHandler.next(a.data);
            if (a.isExpired === true) {
                return this.http
                    .get(url, options)
                    .pipe(tap(a => {
                    cacheHandler.next(a);
                    this.cache.put(this.constructUrl(url, options ? options.params : undefined), a);
                }, map(a => a)), first());
            }
            else {
                return of(a.data);
            }
        }))
            .subscribe();
        this.cachedSubjects.set(this.constructUrl(url, options ? options.params : undefined), cacheHandler);
        return cacheObResponse$;
    }
    constructUrl(url, params) {
        return params
            ? url +
                "?" +
                params
                    .keys()
                    .map(key => key + "=" + params.get(key) + "&")
                    .reduce((first, second) => first + second, "")
            : url;
    }
}
CachedHttpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CachedHttpService_Factory() { return new CachedHttpService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(Cache)); }, token: CachedHttpService, providedIn: "root" });
